module.exports = __webpack_public_path__ + "img/notes-2dolist.95142043.png";